module.exports = __webpack_public_path__ + "static/assets/33b488e871c3b0653efb694b74dca255.png";